<template>
    <div class="menu-social" v-for="(item, index) in result.menusMenus.data" v-if="result">
        <a class="menu-item"
            v-for="(itemMenu, index) in item.attributes.items.data"
            :href="itemMenu.attributes.url"
            target="_blank"
            rel="noopener noreferrer">

                <span class="vh">{{itemMenu.attributes.title}}</span>
                <social-icon :url="itemMenu.attributes.url" />
        </a>
    </div>
</template>

<script lang="ts">

import { defineComponent, ref } from 'vue'

import { useQuery } from '@vue/apollo-composable'
import { SOCIAL_MENU_QUERY } from '../../graphql/social-menu'

import SocialIcon from "../svg/SocialIcon.vue"

export default defineComponent({
    components: {
        SocialIcon
    },
    setup() {
        const homeurl: string = import.meta.env.VITE_API_URL

        const query = ref(SOCIAL_MENU_QUERY)

        const { result } = useQuery(query)

        return {
            result,
            homeurl
        }
    }
})

</script>
